<template>
  <div class="course-config">
    <iframe
      class="course-config-frame"
      :src="src"
      title="日课配置"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
// 日课配置：把前台日历式日课页（/tianxing/autoSelect）内嵌到后台内容区展示。
//
// 为什么用 iframe 而不是直接 import 前台组件：
//   /tianxing/* 页面依赖 TianxingLayout 的 .tianxing-page 作用域（tianxing-scope.scss，
//   内含原站整套页面样式）。直接塞进后台内容区会出现两边样式互相污染（后台主题被原站
//   全局选择器改写，或前台页面在后台样式下走形）；iframe 自带独立文档，前台页面保持
//   与原站一致的外观，后台主题也完全不受影响。
//   这与原系统的工作流一致：老后台的「自动择日」也是一个指向前台 /autoSelect 的 iframe，
//   区别只是现在留在后台内容区里展示，不再新开窗口。
export default {
  name: 'AdminCourseConfig',
  data () {
    return {
      // 同源相对路径：本地 9090、线上域名都自动跟随当前站点，无需按环境切换
      src: '/tianxing/autoSelect'
    }
  }
}
</script>

<style scoped>
.course-config {
  display: flex;
  /* .wrapper-content 是 flex:1 的确定高度，撑满它让 iframe 占满后台内容区 */
  height: 100%;
  /* 小屏兜底：内容区被压扁时不至于把日历挤没 */
  min-height: 560px;
}
.course-config-frame {
  flex: 1;
  width: 100%;
  border: 0;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
</style>
